export function createIndexableMetas({ indexable }) {
  return indexable
    ? []
    : [
        {
          name: 'robots',
          content: 'noindex, follow'
        }
      ];
}

export default {
  createIndexableMetas
};
